export default __webpack_public_path__ + "static/media/prime.d8b58fa9.png";